import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import { animations } from "@styles";

export const wrapper = {
  base: css`
    overflow: hidden;
  `,
  disabled: (theme: Theme) => css`
    background-color: ${theme.disabled.background};
    border-color: ${theme.disabled.border};
  `,
  enabledBorder: (theme: Theme) => css`
    border: 1px solid ${theme.system.borderBase};
    border-radius: ${borders.radiusBase};
  `,
  enabledBorderBottom: (theme: Theme) => css`
    border-bottom: 1px solid ${theme.system.borderBase};
  `,
};

export const triggerWrapper = {
  base: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  `,
  coreContent: css`
    flex-basis: 90%;
  `,
  secondaryContent: css`
    align-items: center;
  `,
  bothContent: css`
    flex-basis: 70%;
  `,
  withChevron: css`
    display: flex;
    column-gap: 0.5rem;
  `,
};

export const triggerButton = {
  base: (theme: Theme) => css`
    padding: 0;
    width: 100%;
    ${animations.transition()}

    &:not([disabled]) {
      cursor: pointer;
    }

    &[disabled] {
      color: ${theme.disabled.text};

      cursor: not-allowed;
    }
  `,
};

export const chevron = (theme: Theme) => css`
  color: ${theme.text.body};
  font-size: ${theme.aviaryTypography.caption.fontSize};
`;

export const padding = {
  medium: css`
    padding: 1rem;
  `,
  small: css`
    padding: 0.5rem;
  `,
  large: css`
    padding: 1.75rem;
  `,
};

export const noHorizontalPadding = css`
  padding-inline: 0;
`;

export const noTopPadding = css`
  padding-top: 0;
`;

export const chevronWrapper = css`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const frame = {
  base: css`
    will-change: transform, opacity, height;
    overflow: hidden;
  `,
  open: css`
    overflow: unset;
  `,
  margin: {
    start: css`
      margin-left: 2rem;
    `,
    end: css`
      margin-right: 2rem;
    `,
  },
};

export const centerTrigger = css`
  align-self: center;
`;
